import { Component, Input, OnInit } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-appointment-modality-tag',
  templateUrl: './appointment-modality-tag.component.html',
  styleUrls: ['./appointment-modality-tag.component.less']
})
export class AppointmentModalityTagComponent implements OnInit {
  _remote: boolean = false;
  _url: string = '';
  _start: Date | null = null;
  _end: Date | null = null;
  _schedulingId: number | null = null;

  // UUID id;
  id: string = uuidv4();

  @Input()
  set start(v: Date | null | undefined) {
    this._start = null;

    if(v) {
      this._start = new Date(v);
    }
  }

  @Input()
  set end(v: Date | null | undefined) {
    this._end = null;

    if(v) {
      this._end = new Date(v);
    }
  }

  @Input()
  set remote(v: boolean | null | undefined) {
    this._remote = v || false;
  }

  @Input()
  set url(v: string | null | undefined) {
    this._url = v || '';
  }
  
  @Input()
  set schedulingId(v: number | null | undefined) {
    this._schedulingId = v || null;
  }

  get startEndText(): string {
    if(this._start && this._end) {
      return `(#${this._schedulingId}) ${this._start.toLocaleString()} - ${this._end.toLocaleString()}`;
    }

    return '';
  }

  constructor() { }

  ngOnInit(): void {
  }

  goToUrl() {
    window.open(this._url, '_blank');
  }

}
